import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import pxToRem from "assets/theme/functions/pxToRem";

const { primary, white, text, grey } = colors;
const { borderRadius } = borders;

const button = {
  defaultProps: {
    disableRipple: false,
  },
  styleOverrides: {
    root: {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: borderRadius.md,
      padding: `${pxToRem(8)} ${pxToRem(20)}`,
      fontSize: pxToRem(14),
      fontWeight: 500,
      textTransform: "none",
      lineHeight: 1.5,
      letterSpacing: "0.01em",
    },
    contained: {
      backgroundColor: primary.main,
      color: white.main,
      "&:hover": { backgroundColor: primary.focus },
    },
    outlined: {
      borderColor: grey[300],
      color: text.main,
      "&:hover": { borderColor: primary.main, color: primary.main, backgroundColor: "transparent" },
    },
    text: {
      color: primary.main,
      "&:hover": { backgroundColor: `rgba(13, 148, 136, 0.04)` },
    },
    sizeSmall: { fontSize: pxToRem(12), padding: `${pxToRem(6)} ${pxToRem(14)}` },
    sizeLarge: { fontSize: pxToRem(16), padding: `${pxToRem(10)} ${pxToRem(28)}` },
  },
};

export default button;
